import { createAsyncThunk } from "@reduxjs/toolkit";
import { setErrorSnackBarMessage, setSnackBarMessage } from "../systemSlice";
import { errorToHandler } from "../../api/error";
import { api } from "api";
import { ApiError, CreateRoleRequest } from "api/controlPlaneApi";

export const fetchRoles = createAsyncThunk(
  "roles/fetchRoles",
  async (_, { rejectWithValue, getState, dispatch }) => {
    return api.authorization
      .listRoles()
      .then((res) => {
        return res.data.results;
      })
      .catch(async (res) => {
        const err = (await res.json()) as ApiError;
        dispatch(setErrorSnackBarMessage(errorToHandler(err)));
        return rejectWithValue(res);
      });
  },
);

export const fetchRoleDetails = createAsyncThunk(
  "roles/fetchRoleDetails",
  async (roleID: string, { rejectWithValue, getState, dispatch }) => {
    return api.authorization
      .getRole(roleID)
      .then((res) => {
        return res.data;
      })
      .catch(async (res) => {
        const err = (await res.json()) as ApiError;
        dispatch(setErrorSnackBarMessage(errorToHandler(err)));
        return rejectWithValue(res);
      });
  },
);

export const deleteRole = createAsyncThunk(
  "roles/deleteRole",
  async (roleID: string, { rejectWithValue, getState, dispatch }) => {
    return api.authorization
      .deleteRole(roleID)
      .then(() => {
        dispatch(setSnackBarMessage("Role deleted successfully"));
      })
      .catch(async (res) => {
        const err = (await res.json()) as ApiError;
        dispatch(setErrorSnackBarMessage(errorToHandler(err)));
        return rejectWithValue(res);
      });
  },
);

export const addRole = createAsyncThunk(
  "roles/addRole",
  async (role: CreateRoleRequest, { rejectWithValue, getState, dispatch }) => {
    return api.authorization
      .createRole(role, { headers: { "Content-Type": "application/json" } })
      .then(() => {
        dispatch(setSnackBarMessage("Role added successfully"));
      })
      .catch(async (res) => {
        const err = (await res.json()) as ApiError;
        dispatch(setErrorSnackBarMessage(errorToHandler(err)));
        return rejectWithValue(res);
      });
  },
);

export const editRole = createAsyncThunk(
  "roles/editRole",
  async (role: any, { rejectWithValue, getState, dispatch }) => {
    let id = role.id;
    delete role.id;
    return api.authorization
      .updateRole(id, role, { headers: { "Content-Type": "application/json" } })
      .then(() => {
        dispatch(setSnackBarMessage("Role updated successfully"));
      })
      .catch(async (res) => {
        const err = (await res.json()) as ApiError;
        dispatch(setErrorSnackBarMessage(errorToHandler(err)));
        return rejectWithValue(res);
      });
  },
);

export const fetchActions = createAsyncThunk(
  "roles/fetchActions",
  async (_, { rejectWithValue, getState, dispatch }) => {
    return api.authorization
      .listActions()
      .then((res) => {
        return res.data.results;
      })
      .catch(async (res) => {
        const err = (await res.json()) as ApiError;
        dispatch(setErrorSnackBarMessage(errorToHandler(err)));
        return rejectWithValue(res);
      });
  },
);

export const fetchResources = createAsyncThunk(
  "roles/fetchResources",
  async (_, { rejectWithValue, getState, dispatch }) => {
    return api.authorization
      .listResources()
      .then((res) => {
        return res.data.results;
      })
      .catch(async (res) => {
        const err = (await res.json()) as ApiError;
        dispatch(setErrorSnackBarMessage(errorToHandler(err)));
        return rejectWithValue(res);
      });
  },
);
